// frontend/src/contexts/CookieContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";

const CookieContext = createContext();

export function useCookies() {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error("useCookies must be used within CookieProvider");
  }
  return context;
}

export function CookieProvider({ children }) {
  const [preferences, setPreferences] = useState({
    necessary: true, // Sempre ativo
    statistics: false,
    marketing: false,
    accepted: false, // Se o usuário já respondeu
  });

  // Carregar preferências salvas ao iniciar
  useEffect(() => {
    const saved = localStorage.getItem("cookie-preferences");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setPreferences({
          necessary: true,
          statistics: parsed.statistics || false,
          marketing: parsed.marketing || false,
          accepted: true,
        });
      } catch (e) {
        console.error("Erro ao carregar preferências de cookies", e);
      }
    }
  }, []);

  // Aceitar todos os cookies
  const acceptAll = () => {
    const newPrefs = {
      necessary: true,
      statistics: true,
      marketing: true,
      accepted: true,
    };
    setPreferences(newPrefs);
    localStorage.setItem(
      "cookie-preferences",
      JSON.stringify({
        statistics: true,
        marketing: true,
      })
    );
    // Disparar evento para outras partes da aplicação
    window.dispatchEvent(new CustomEvent("cookies-updated", { detail: newPrefs }));
  };

  // Rejeitar todos (exceto necessários)
  const rejectAll = () => {
    const newPrefs = {
      necessary: true,
      statistics: false,
      marketing: false,
      accepted: true,
    };
    setPreferences(newPrefs);
    localStorage.setItem(
      "cookie-preferences",
      JSON.stringify({
        statistics: false,
        marketing: false,
      })
    );
    window.dispatchEvent(new CustomEvent("cookies-updated", { detail: newPrefs }));
  };

  // Salvar preferências personalizadas
  const savePreferences = (statistics, marketing) => {
    const newPrefs = {
      necessary: true,
      statistics,
      marketing,
      accepted: true,
    };
    setPreferences(newPrefs);
    localStorage.setItem(
      "cookie-preferences",
      JSON.stringify({
        statistics,
        marketing,
      })
    );
    window.dispatchEvent(new CustomEvent("cookies-updated", { detail: newPrefs }));
  };

  // Verificar se o usuário já respondeu
  const hasAccepted = preferences.accepted;

  return (
    <CookieContext.Provider
      value={{
        preferences,
        acceptAll,
        rejectAll,
        savePreferences,
        hasAccepted,
      }}
    >
      {children}
    </CookieContext.Provider>
  );
}